var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerDefaultShortLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(-1116 -486)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "NoPath_-_Copy_2_",
    "data-name": "NoPath - Copy (2)",
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    transform: "translate(1116 486)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Add_Logo",
    "data-name": "Add Logo",
    transform: "translate(1177 552)",
    fill: "#504658",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.625,
    y: -5
  }, "Add short"), /*#__PURE__*/React.createElement("tspan", {
    x: -34.625,
    y: 18
  }, "Logo")), /*#__PURE__*/React.createElement("g", {
    id: "NoPath_-_Copy_2_2",
    "data-name": "NoPath - Copy (2)",
    transform: "translate(1121 491)",
    fill: "none",
    stroke: "#dde7f1",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerDefaultShortLogo);
export default __webpack_public_path__ + "static/media/partner-default-short-logo.cf2ecc8912a7a86020ae3aea68b127fe.svg";
export { ForwardRef as ReactComponent };